"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Avatar = _interopRequireDefault(require("./Avatar.style"));

var _dec, _class;

let Avatar = (_dec = (0, _reactJss.default)(_Avatar.default), _dec(_class = class Avatar extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageError: true
    };
    this.avatarEl = _react.default.createRef();
    this.handleClick = this.handleClick.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.label !== this.props.label || nextProps.size !== this.props.size || nextProps.src !== this.props.src || nextProps.textColor !== this.props.textColor || nextProps.bgColor !== this.props.bgColor || nextProps.badge !== this.props.badge || nextProps.className !== this.props.className || nextState.imageError !== this.state.imageError) {
      return true;
    }

    return false;
  }

  componentDidMount() {
    if (this.props.src) {
      this.loadImage(this.props.src);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.loadImage(this.props.src);
    }
  }

  loadImage(src) {
    const hdLoaderImg = new Image();

    hdLoaderImg.onload = () => {
      if (this.avatarEl.current) {
        this.avatarEl.current.style.backgroundImage = `url('${src}')`;
        this.setState({
          imageError: false
        });
      }
    };

    hdLoaderImg.onerror = () => {
      if (this.avatarEl.current) {
        this.avatarEl.current.setAttribute('style', '');
        this.setState({
          imageError: true
        });
      }
    };

    hdLoaderImg.src = src;
  }

  getInitials(label) {
    if (!label) return '';
    return label.trim().split(/\s+/).map(n => n[0] ? n[0].toUpperCase() : '').splice(0, 2).join('');
  }

  handleClick() {
    const {
      onClick
    } = this.props;
    onClick();
  }

  renderInitials() {
    const {
      label
    } = this.props;
    return _react.default.createElement("span", null, this.getInitials(label));
  }

  render() {
    const {
      children,
      className,
      classes,
      size,
      badge,
      id,
      src,
      bgColor,
      textColor,
      onMouseEnter,
      onMouseLeave
    } = this.props;
    const {
      imageError
    } = this.state;
    const baseClasses = (0, _clsx.default)(className, classes.avatar, classes[size]);
    return _react.default.createElement("div", {
      id: id,
      ref: this.avatarEl,
      className: baseClasses,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      style: {
        backgroundColor: bgColor,
        color: textColor
      },
      onClick: this.handleClick
    }, children, badge && _react.default.cloneElement(badge, {
      className: 'status'
    }), !src || imageError ? this.renderInitials() : null);
  }

}) || _class);
Avatar.defaultProps = {
  size: 'medium',
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  children: null,
  badge: null
};
var _default = Avatar;
exports.default = _default;